import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`About Me`}</h2>
    <h4>{`Experiment => Fail => Learn => Repeat. It always seems impossible until it!`}</h4>
    <p>{`Computer Science Graduate seeking to become a `}<strong parentName="p">{`Professional Web Developer`}</strong>{` to utilize my skills to develop solutions that solve real life problems.
My skillsets includes:`}</p>
    <ul>
      <li parentName="ul">{`Enthusiastic`}</li>
      <li parentName="ul">{`Problem Solver`}</li>
      <li parentName="ul">{`Goal Oriented`}</li>
      <li parentName="ul">{`Eager to Learn`}</li>
      <li parentName="ul">{`HTML/CSS/JavaScript/Bootstrap`}</li>
      <li parentName="ul">{`Wordpress`}</li>
      <li parentName="ul">{`React JS`}</li>
      <li parentName="ul">{`C# Windows Form Application`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      